//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/UserDefinedObjects.js";
import "../no/TransientObject.js";
let d=[[[0,"AllowOwnedObjectSelectionOption",1,0],[0,"AllowQueryClassFromName",1,0],[0,"ClassName",0,0],[0,"FriendlyName",0,0],[0,"WarnUserFlag",1,0]],[[[],"Dispose",{},0,0],[[],"GetIsOccurrenceableFlag",{R_:{is_occurrenceable:''}},0,0],[["is_occurrenceable"],"SetIsOccurrenceableFlag",{},1,0]],[]];
SPLM.UserDefinedObjects.UserDefinedClass = class extends SPLM.TransientObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.UserDefinedObjects.UserDefinedClass";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.UserDefinedObjects.UserDefinedClass.AllowOwnedObjectSelection = Object.freeze({
    "Off" : "Off", "On" : "On"});

SPLM.UserDefinedObjects.UserDefinedClass.AllowQueryClass = Object.freeze({
    "Off" : "Off", "On" : "On"});

SPLM.UserDefinedObjects.UserDefinedClass.Selection = Object.freeze({
    "Off" : "Off", "On" : "On"});

export default SPLM;